import React from "react";
import { Button } from "@mui/material";

function GeneralInformationSaveBar(props) {
  const { translate, isLoading, isModified, onSave } = props;

  return (
    <div className="button-container-form-gi">
      <Button
        variant="contained"
        onClick={onSave}
        style={
          isModified && !isLoading
            ? { backgroundColor: "red", color: "white", marginLeft: "15px" }
            : { backgroundColor: "#1565C0", color: "white", marginLeft: "15px" }
        }
        disabled={isLoading}
        sx={{ height: "40px", width: "auto", marginLeft: "25px", marginRight: "30px" }}
      >
        {isLoading
          ? translate("SavingModifications")
          : isModified
          ? translate("ClickToSave")
          : translate("SaveModifications")}
      </Button>
    </div>
  );
}

export default GeneralInformationSaveBar;
